import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationStore } from "@/store/navigationStore";
import { useAuthStore } from "@/store/authStore";
import {
  SideBarContainer,
  SideBarMenuContainer,
  TopContainer,
  BottomContainer,
} from "./styles";
import { Logo } from "./Logo";
import { MainMenu } from "./MainMenu";
import { LogoutButton } from "./LogoutButton";
import { ToggleButton } from "./ToggleButton";
import { Inquiry } from "./Inquiry";

const GradientDefs: React.FC = () => (
  <svg width="0" height="0">
    <defs>
      <linearGradient id="sidebarGradient" x1="100%" y1="100%" x2="0%" y2="0%">
        <stop offset="0%" stopColor="rgba(112, 122, 149, 1)" />
        <stop offset="50%" stopColor="rgba(29, 59, 98, 1)" />
        <stop offset="100%" stopColor="rgba(1, 8, 46, 1)" />
      </linearGradient>
    </defs>
  </svg>
);

const SideBar: React.FC = () => {
  const {
    activeButton,
    isCollapsed,
    subMenuStates,
    setActiveButton,
    setIsCollapsed,
    toggleSubMenu,
    closeAllSubMenus,
  } = useNavigationStore();
  const { user, logout, accessToken } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.replace("/", "");
    if (currentPath && currentPath !== activeButton) {
      setActiveButton(currentPath);
    }
  }, [location.pathname, activeButton, setActiveButton]);

  useEffect(() => {
    // console.log("Auth State:", { accessToken, user });
  }, [accessToken, user]);

  const handleButtonClick = (buttonId: string): void => {
    setActiveButton(buttonId);
    if (buttonId === "guide") {
      window.open("https://mago-1.gitbook.io/audion-python-sdk/", "_blank");
      return;
    }
    navigate(`/${buttonId}`);
  };

  const expandSideBar = (menuId: "flow" | "mypage"): void => {
    setIsCollapsed(false);
    toggleSubMenu(menuId);
  };

  const handleToggleClick = (): void => {
    setIsCollapsed(!isCollapsed);
    closeAllSubMenus();
  };

  const handleLogout = async (): Promise<void> => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("로그아웃 실패:", error);
    }
  };

  const handleProjectClick = async (projectId: string) => {
    setActiveButton(projectId);
    navigate("/upload");
  };

  return (
    <SideBarContainer $isCollapsed={isCollapsed}>
      <GradientDefs />
      <SideBarMenuContainer>
        <TopContainer>
          <Logo isCollapsed={isCollapsed} />
          <MainMenu
            isCollapsed={isCollapsed}
            activeButton={activeButton}
            subMenuStates={subMenuStates}
            handleButtonClick={handleButtonClick}
            toggleSubMenu={toggleSubMenu}
            expandSideBar={expandSideBar}
          />
        </TopContainer>
        <BottomContainer>
          <Inquiry isCollapsed={isCollapsed} />
          <LogoutButton
            isCollapsed={isCollapsed}
            accessToken={accessToken}
            username={user?.name || ""}
            onLogoutClick={handleLogout}
          />
        </BottomContainer>
      </SideBarMenuContainer>
      <ToggleButton isCollapsed={isCollapsed} onClick={handleToggleClick} />
    </SideBarContainer>
  );
};

export { SideBar };
export default SideBar;
